import api from './api';

export const userService = {
  getProfile: async () => {
    return api.get('/users/me');
  },

  updateProfile: async (data) => {
    return api.put('/users/me', data);
  },

  updatePreferences: async (preferences) => {
    return api.put('/users/me/preferences', { preferences });
  },

  changePassword: async (data) => {
    return api.post('/auth/change-password', data);
  },

  deleteAccount: async (password) => {
    return api.delete('/users/me', { data: { password } });
  },

  sendDigest: async () => {
    return api.post('/users/me/send-digest');
  },

  uploadAvatar: async (avatar) => {
    return api.put('/users/me/avatar', { avatar });
  },
};

export default userService;
